export default __webpack_public_path__ + "static/media/ISSO CLASS-10_SYLLABUS_2025-26.ed447650.pdf";